<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-btn x-large class="myYellow3 ml-8" to="/">
          <v-icon left>mdi-chevron-left</v-icon> BACK
        </v-btn>
      </v-col>
    </v-row>
    <v-card
      class="pa-2 ma-8 d-flex flex-column align-center transparent"
      elevation="20"
    >
      <!-- SEAT  -->
      <v-card class="pa-4 mb-4" width="600">
        <v-container class="d-flex pa-0 mb-1">
          <v-container class="pa-0">
            <h4>Invoice Number</h4>
            <p class="text-caption">{{ allData.bill }}</p>
          </v-container>
          <v-container class="pa-0">
            <h4>Time</h4>
            <p class="text-caption">
              {{ allData.date_order }} WIB {{ allData.date }}
            </p>
          </v-container>
        </v-container>
        <v-container class="d-flex pa-0 mb-1">
          <v-container class="pa-0">
            <h4>Customer</h4>
            <p class="text-caption">{{ allData.customer_name }}</p>
          </v-container>
          <v-container class="pa-0">
            <h4>Seating</h4>
            <p class="text-caption">{{ allData.tableName }}</p>
          </v-container>
        </v-container>
        <v-container class="d-flex pa-0 mb-1">
          <v-container class="pa-0">
            <h4>Payment Method</h4>
            <p class="text-caption">{{ allData.payment_type }}</p>
          </v-container>
        </v-container>
      </v-card>

      <!-- DETAIL MENU -->

      <v-card class="pa-4 mb-4" width="600">
        <v-container class="d-flex pa-0">
          <h3>Order Details</h3>
        </v-container>

        <v-divider class="mb-4"></v-divider>

        <v-container
          class="d-flex pa-0 mb-1"
          v-for="item in allData.checkout_details"
          :key="item.id"
        >
          <v-container class="pa-0">
            <h5>{{ item.menu }}</h5>
            <p class="text-caption">Quantity: {{ item.quantity }}</p>
          </v-container>
          <v-container class="pa-0 text-right">
            <h4>{{ parseRupiah(item.price * item.quantity) }},-</h4>
          </v-container>
        </v-container>

        <v-divider class="my-2"></v-divider>

        <v-container class="d-flex pa-0 mb-1">
          <v-container class="pa-0">
            <h4>Price</h4>
          </v-container>
          <v-container class="pa-0 text-right">
            <h4>{{ parseRupiah(getPriceBeforeDiscount()) }},-</h4>
          </v-container>
        </v-container>
        <v-container class="d-flex pa-0 mb-1">
          <v-container class="pa-0">
            <h4>Platform Fee</h4>
          </v-container>
          <v-container class="pa-0 text-right">
            <h4>{{ parseRupiah(getTotalPaymentMethod()) }},-</h4>
          </v-container>
        </v-container>
        <v-container class="d-flex pa-0 mb-1">
          <v-container class="pa-0">
            <h4>Discount</h4>
          </v-container>
          <v-container class="pa-0 text-right">
            <h4>{{ parseRupiah(getTotalDiscount()) }},-</h4>
          </v-container>
        </v-container>

        <v-divider class="my-2"></v-divider>

        <v-container class="d-flex pa-0 mb-1">
          <v-container class="pa-0">
            <h4>Total</h4>
          </v-container>
          <v-container class="pa-0 text-right">
            <h4>{{ parseRupiah(getTotalPrice()) }},-</h4>
          </v-container>
        </v-container>
      </v-card>

      <!-- PAYMENT CONDITION -->

      <v-card
        class="pa-4 mb-4"
        width="600"
        v-if="allData.payment_type == 'Bank Transfer'"
      >
        <v-container class="d-flex pa-0">
          <h3>Payment Proof</h3>
        </v-container>

        <v-divider class="mb-4"></v-divider>

        <v-img v-if="allData.proof" :src="allData.proof"> </v-img>

        <v-card
          v-else
          class="pa-8 text-center text-h6 font-weight-bold"
          elevation="8"
        >
          BELUM ADA DATA
        </v-card>
      </v-card>

      <v-card
        class="pa-4 mb-4"
        width="600"
        height="auto"
        v-if="allData.payment_type == 'Cash' || allData.payment_type == 'EDC'"
      >
        <v-container class="d-flex pa-0">
          <h3>Nominal Pembayaran</h3>
        </v-container>

        <v-divider class="mb-4"></v-divider>

        <v-text-field
          v-if="allData.status == 'waiting for payment'"
          v-model="nominal"
          label="Pembayaran"
          outlined
          dense
          type="number"
        ></v-text-field>

        <v-card
          v-if="allData.status == 'order processing'"
          class="pa-2"
          elevation="8"
        >
          <div class="d-flex justify-space-between my-1 font-weight-bold">
            <div>Total Payment</div>
            <div>{{ parseRupiah(allData.total_received) }},-</div>
          </div>
          <div class="d-flex justify-space-between my-1 font-weight-bold">
            <div>Total Cart</div>
            <div>{{ parseRupiah(getTotalPrice()) }},-</div>
          </div>
          <v-divider class="my-2"></v-divider>
          <div class="d-flex justify-space-between my-1 font-weight-bold">
            <div>Change</div>
            <div>
              {{ parseRupiah(allData.total_received - getTotalPrice()) }},-
            </div>
          </div>
        </v-card>

        <v-card v-show="showChange" class="mb-4 pa-2">
          <div class="d-flex justify-space-between my-1">
            <div>Total Payment</div>
            <div>{{ parseRupiah(nominalPayment.nominal) }},-</div>
          </div>
          <div class="d-flex justify-space-between my-1">
            <div>Total Cart</div>
            <div>{{ parseRupiah(getTotalPrice()) }},-</div>
          </div>
          <div class="d-flex justify-space-between my-1">
            <div>Change</div>
            <div>
              {{ parseRupiah(nominalPayment.nominal - getTotalPrice()) }},-
            </div>
          </div>
        </v-card>

        <v-btn
          v-if="allData.status == 'waiting for payment'"
          block
          class="myYellow2"
          @click="
            () => {
              NOMINAL_PAYMENT({ nominal });
              showChange = true;
            }
          "
        >
          SUBMIT
        </v-btn>
      </v-card>

      <!-- STATUS  -->

      <v-card
        v-if="allData.status == 'waiting for payment'"
        class="pa-4 mb-4 d-flex justify-center myYellow3 font-weight-bold"
        width="600"
      >
        WAITING FOR PAYMENT
      </v-card>
      <v-card
        v-else-if="allData.status === 'order processing'"
        elevation="0"
        class="transparent"
      >
        <div class="d-flex justify-center">
          <v-btn block class="pa-4 mb-4 myGreen2" @click="getPDF">
            <v-icon left small>mdi-download-circle-outline</v-icon>
            Bill
          </v-btn>
        </div>
        <v-card
          class="pa-4 mb-4 d-flex justify-center myBlue white--text font-weight-bold"
          width="600"
        >
          ORDER PROCESSING
        </v-card>
      </v-card>

      <!-- APPROVED BY -->

      <v-card
        v-if="allData.status == 'waiting for payment'"
        class="pa-4 mb-4"
        width="600"
      >
        <v-container class="d-flex pa-0">
          <h3>Approved By</h3>
        </v-container>

        <v-divider class="mb-4"></v-divider>

        <v-select
          v-model="personSelected"
          :items="employeeName"
          label="Select Name"
          dense
          outlined
        ></v-select>
      </v-card>

      <!-- BUTTON  -->

      <v-card
        v-if="allData.status == 'waiting for payment'"
        class="pa-4 mb-4 d-flex justify-space-between"
        width="600"
      >
        <!-- <v-btn color="myGreen" outlined small>
          <v-icon left small>mdi-download-circle-outline</v-icon> Bill
        </v-btn> -->

        <!-- button approve digunakan untuk merubah status waiting ke Order -->
        <v-btn
          color="myRed white--text"
          @click="DELETE_ORDER($route.params.id)"
        >
          Delete
        </v-btn>

        <v-btn
          v-if="allData.payment_type == 'Bank Transfer'"
          color="myGreen white--text"
          @click="
            APPROVED_BY_BANK_TRANSFER({ id: $route.params.id, personSelected })
          "
          :disabled="personSelected == '' || allData.proof == null"
        >
          Approve <v-icon right small>mdi-chevron-right</v-icon>
        </v-btn>

        <v-btn
          v-else-if="allData.payment_type == 'Cash'"
          color="myGreen white--text"
          @click="
            APPROVED_BY_CASH({
              id: $route.params.id,
              personSelected,
              change: nominalPayment.nominal - getTotalPrice(),
            })
          "
          :disabled="personSelected == ''"
        >
          Approve <v-icon right small>mdi-chevron-right</v-icon>
        </v-btn>

        <v-btn
          v-else-if="allData.payment_type == 'EDC'"
          color="myGreen white--text"
          @click="
            APPROVED_BY_CASH({
              id: $route.params.id,
              personSelected,
              change: nominalPayment.nominal - getTotalPrice(),
            })
          "
          :disabled="personSelected == ''"
        >
          Approve <v-icon right small>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      nominal: "",
      showChange: false,
      personSelected: "",
      allData: [],
      employeeName: [],
    };
  },
  methods: {
    getPDF() {
      let config = {
        method: "get",
        url:
          process.env.VUE_APP_BASE_URL +
          "/invoiceCashier/" +
          this.$route.params.id,
        responseType: "blob",
      };
      axios(config)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${this.allData.bill}.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => console.log(err));
    },
    ...mapActions([
      "GET_TABLE",
      "GET_EMPLOYEE",
      "NOMINAL_PAYMENT",
      "APPROVED_BY_BANK_TRANSFER",
      "APPROVED_BY_CASH",
      "DELETE_ORDER",
    ]),
    fetchData() {
      const fetchedId = this.$route.params.id;
      const result = this.table.find((tab) => tab.id == fetchedId);
      this.allData = result;
    },

    getTotalPrice() {
      return this.allData.total_price;
    },
    getPriceBeforeDiscount() {
      return this.allData.total_price + this.allData.total_discount;
    },

    getTotalPaymentMethod() {
      if (
        this.allData.payment_type == "Bank Transfer" ||
        this.allData.payment_type == "EDC" ||
        this.allData.payment_type == "Cash"
      ) {
        return 0;
      } else {
        return 500;
      }
    },

    getTotalDiscount() {
      return this.allData.total_discount;
    },

    parseRupiah(price) {
      if (price == null) {
        return "";
      } else {
        return (
          "Rp. " +
          price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
        );
      }
    },
  },
  computed: {
    ...mapGetters(["table", "employee", "nominalPayment"]),
  },
  mounted() {
    const fetchedId = this.$route.params.id;
    this.employeeName = this.employee.map((person) => person.name);
    window.Echo.channel("cashier-order").listen("CashierOrder", (e) => {
      const result = e.homes.find((tab) => tab.id == fetchedId);
      this.allData = result;
    });
  },
  created() {
    this.fetchData();
    this.GET_EMPLOYEE();
    this.GET_TABLE();
  },
};
</script>
